import React from "react";
import Flashcard from "./Flashcard";

export default function Flashcards(props) {
  const { flashcards, current } = props;
  if (flashcards.length === 0) {
    return <div>Loading...</div>;
  }
  return (
    <div className="card-div">
      {<Flashcard flashcard={flashcards[current]} key={flashcards[current].id} /> }
    </div>
  );
}
